export const PageNotFound = () => {
    return (
        <div style={{margin: "100px"}}>Page not found :(</div>
    )
}
